import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonTabs } from './Tabs.definition';
import { chameleonTab } from './Tab/Tab.definition';
import { chameleonTabPanel } from './TabPanel/TabPanel.definition';
provideChameleonDesignSystem().register(chameleonTab(), chameleonTabPanel(), chameleonTabs());
